const CONTACT_URLS = {
  INSERT: "/contact/insert",
  GET_USER_CONTACT: "/contact/get_user_contact",
  GET_ALL: "/contact/get_all",
  GET_ONE: "/contact/get_one",
  DELETE_ONE: "/contact/delete_one",
};
const CONTACT_US_URLS = {
  INSERT: "/contact_us/insert",

  GET_ALL: "/contact_us/get_all",
 
};


export { CONTACT_URLS,CONTACT_US_URLS };

